export enum Sources {
  ANDROID_V2 = 1,
  IOS_V1_V2,
  IOS_V3,
  WEBSITE,
  THUISBEZORGD_NL,
  DELIVEROO,
  UBER_EATS,
  HOMIE,
  IOS_WEB_APP = 17,
  ANDROID_WEB_APP = 18,
  POS = 19,
  IOS_NATIVE_APP = 20,
  ANDROID_NATIVE_APP = 21,
  QR = 22,
  KIOSK = 23,
  TRENDYOL_GO,
  All_SOURCES = 100,
  FINANCIAL_ALL = 100001,
  FINANCIAL_OWN_CHANNEL_ALL = 100002,
  FINANCIAL_APP_ALL = 100003,
  FINANCIAL_WEBSITE_AND_APP = 100004,
}

export enum OrderStatus {
  ARRIVED = 1,
  CONFIRMED,
  IN_KITCHEN,
  EN_ROUTE,
  HANDED_OVER,
  READY_FOR_DELIVERY = 7,
  ASSIGNED_TO_COURIER,
  READY_FOR_PACKAGING,
  CANCELLED = 11,
  DELETED,
  DUPLICATED,
  UNPAID,
  EXPIRED,
  BLOCKED,
  REFUNDED,
  CLEAN_UP,
  REJECTED,
  UNPAID_BUT_VISIBLE = 54,
}

export enum DeliveryMethods {
  DELIVERY = 1,
  TAKEAWAY,
  DINE_IN,
  POS_ORDER,
  QR_TABLE_ORDER,
  ORDER_KIOSK,
  WAITER_ORDER,
  DELIVERY_BY_EXTERNAL,
  TAKEOUT,
}

export enum TargetUrlParams {
  ALL = 0,
  DELIVERY,
  TAKEAWAY,
  DINE_IN,
  POS,
  QR_ORDER,
  KIOSK,
}

export enum CartContentType {
  PRODUCT = "1",
  TOPPING = "2",
  DISCOUNT_VALUE = "3",
  DISCOUNT_PRODUCT = "4",
  SERVICE_COST = "5",
  DELIVERY_COST = "6",
  TIP = "7",
  LOYALTY_POINTS = "8",
  CUSTOM = "9" /* The item is a custom order item (a custom dish created during an intake for a internal pos order for example). */,
  CUSTOM_TOPPING = "10",
  EXTRA_COST = "11",
  LOYALTY_POINTS_SPENDAGE = "12",
}

export enum InternalMessageType {
  CUSTOMER_MESSAGE = 1,
  INFORMATION_MESSAGE,
  ERROR_MESSAGE,
  APPSMEN_MESSAGE,
}

export enum NewsletterCampaignStatus {
  SENT = 1,
  DELIVERED,
  CLICK,
  OPENED,
  BLOCKED,
  SPAM,
  INVALID,
  SOFT_BOUNCE,
  HARD_BOUNCE,
  DEFERRED,
  UNIQUE_OPENED,
}

export enum AlarmFileSounds {
  DOOR_BELL = 1,
  GUITAR,
  JOYOUS,
  PROUD,
  UPSET,
  RELAX,
  GONG,
  BEEP = 100,
}

export enum DiscountType {
  DISCOUNT_CODE = 1,
  WEBSITE_AND_DISCOUNT,
  GENERATED_DISCOUNT,
}
export enum CountryCode {
  ALL = 0,
  NETHERLANDS = 1,
  BELGIUM = 2,
  TURKIYE = 3,
}

export enum GeneratorTypes {
  CONFIRMATION_MAIL = 1,
  RECEIPT,
  REVIEW,
  PASSIVE_CUSTOMER,
  BIRTHDAY,
}

export enum ProductEnum {
  RESTAURANT = 1,
  SUPERMARKET,
  NIGHT_SHOP,
}

export enum MenuItems {
  CATEGORY = "1",
  PRODUCT = "2",
  GARNISH = "3",
  TOPPING = "4",
}

export enum ReceiptEnum {
  Default_Receipt = "Default_Receipt",
  Default_Receipt2 = "Default_Receipt2",
  Default_Receipt3 = "Default_Receipt3",
  Default_Receipt_Label = "Default_Receipt_Label",
}

export enum CategoryType {
  NORMAL = 1,
  FAVORITE = 2,
}

export enum CategoryCardPositionEnum {
  STANDARD = 1,
  LEFT,
  TOP,
}

export enum PaymentMethodEnum {
  CASH = 1,
  IDEAL,
  DEBIT_CARD,
  BAN_CONTACT,
  CASH_NOT_EXACT,
  PAY_CONIQ,
  DEBIT_CARD_AT_DELIVERY,
  PAY_CONIQ_QR_CODE,
  ONLINE_PAID_IN_EXTERNAL_SYSTEM,
  CREDIT_CARD,
  CREDIT_CARD_POS,
  PAYPAL,
  INVOICE_LATER,
  VISA,
  MASTERCARD = 16,
  VOUCHER,
  EXPRESS_PAY,
  CHEQUE,
  ONLINE_BANK_TRANSFER,
  GIFT_CARD,
  POS_TERMINAL,
  PAYMENT_METHOD_NOT_KNOWN_YET,
  SPLIT_PAYMENT = 25,
  PLUXEE_ONLINE = 26,
  SODEXO_CARD_AT_DELIVERY = 27,
  MULTINET_ONLINE = 28,
  SODEXO_CODE_AT_DELIVERY = 29,
  EDENRED_ONLINE = 30,
  MULTINET_CARD_AT_DELIVERY = 31,
  SETCARD_ONLINE = 32,
  MULTINET_CODE_AT_DELIVERY = 33,
  EDENRED_CARD_AT_DELIVERY = 35,
  EDENRED_CODE_AT_DELIVERY = 37,
  SETCARD_CARD_AT_DELIVERY = 39,
  SETCARD_CODE_AT_DELIVERY = 41,
  METROPOL_CARD_AT_DELIVERY = 43,
  METROPOL_CODE_AT_DELIVERY = 45,
  TOKENFLEX_MOBILE_AT_DELIVERY = 47,
  TOKENFLEX_CODE_AT_DELIVERY = 49,
  PAYEKART_CARD_AT_DELIVERY = 51,
  PAYEKART_CODE_AT_DELIVERY = 53,
  IWALLET_CODE_AT_DELIVERY = 55,
  OTHERWISE = 101,
  ONLINE = 103,
  ALL = 1000,
}

export enum PaymentStatusEnum {
  PENDING_PAYMENT_AFTER_ORDER_CHANGE = 10,
  PENDING_PAYMENT = 11,
  PAID = 100,
}

export const enum SortBy {
  PLACED_DATE_TIME = "PLACED_DATE_TIME",
  HAND_OVER_TIME = "HAND_OVER_TIME",
  ZIP_CODE = "ZIP_CODE",
  SOURCE = "SOURCE",
  STATUS = "STATUS",
}

export const enum None {
  NONE = 0,
}

export const enum FlyerPaymentStatus {
  PENDING = 20,
  PAID = 100,
}

export const enum CustomDiscountType {
  PERCENTAGE = 1,
  FIXED_PRICE = 2,
}

export const enum SoundEngineType {
  USE_SOUND = "use-sound",
  HOWLER = "howler",
}

export enum CalendarUnitEnum {
  CALENDAR_DAY = 1,
  WEEK = 3,
  MONTH,
  QUARTER,
  YEAR,
}

export enum OrderTransactionPrices {
  CASH = 1,
  IDEAL,
  DEBIT_CARD,
  BAN_CONTACT,
  CASH_NOT_EXACT,
  PAY_CONIQ,
  DEBIT_CARD_AT_DELIVERY,
  PAY_CONIQ_QR_CODE,
  ONLINE,
  CREDIT_CARD,
  CREDIT_CARD_POS,
  PAYPAL,
  INVOICE_LATER,
  VISA,
  MASTERCARD = 16,
  VOUCHER,
  EXPRESS_PAY,
  CHEQUE,
  ONLINE_BANK_TRANSFER,
  GIFT_CARD,
  POS_TERMINAL,
  PAYMENT_METHOD_NOT_KNOWN_YET,
  SPLIT_PAYMENT = 25,
  OTHERWISE = 101,
  REFUND_IDEAL = 201,
  REFUND_BANCONTACT = 202,
  REFUND_PAYCONIQ = 203,
  REFUND_PAYPAL = 204,
  REFUND_VISA = 205,
  REFUND_MASTERCARD = 206,
  REFUND_CREDITCARD = 207,
  BALANCE_PAYOUT = 210,
  TIP_IDEAL = 211,
  TIP_BANCONTACT = 212,
  TIP_PAYCONIQ = 213,
  TIP_PAYPAL = 214,
  TIP_VISA = 215,
  TIP_MASTERCARD = 216,
  TIP_CREDITCARD = 217,
  POS_TERMINAL_MAESTRO_DEBITCARD = 221,
  POS_TERMINAL_V_PAY_DEBITCARD = 222,
  POS_TERMINAL_CREDITCARD = 223,
  SINGLE_SMS = 1001,
}

export enum ProductStatusEnums {
  AVAILABLE = 1,
  SOLD_OUT = 11,
  OUT_OF_STOCK = 12,
  SOLD_OUT_FOR_TODAY = 13,
}

export enum VoipCallStatus {
  CONNECTED = "CONNECTED",
  INCOMING = "INCOMING_RINGING",
}
export enum ToppingContentTypes {
  MANDATORY = 1,
  OPTIONAL = 2,
  CHECKBOX = 3,
}

export enum Language {
  ALL = 0,
  DUTCH,
  GERMAN,
  ENGLISH,
  FRENCH,
  SPANISH,
  TURKISH,
  SERBIAN,
  BELGIUM_DUTCH,
  BELGIUM_FRENCH,
  CHINESE,
  POLISH,
  ARABIC,
}

export enum VatEnum {
  VAT_NL_NONE = 1,
  VAT_NL_LOW = 2,
  VAT_NL_HIGH = 3,
  VAT_BE_NONE = 6,
  VAT_BE_LOW = 7,
  VAT_BE_HIGH = 8,
  VAT_BE_STANDARD = 9,
  VAT_TR_LOW = 10,
  VAT_TR_STANDARD = 11,
}

export enum RevenueTypeEnum {
  TOTAL_REVENUE = 5,
  TOTAL_AMOUNT = 6,
}

export enum AccountRequirementEnum {
  NO_REQUIREMENT = 1,
  REQUIRED_FOR_OFFLINE_PAYMENT,
  ACCOUNT_REQUIRED_FOR_ALL_ORDERS,
}

export enum ExternalDriverStatusEnum {
  UNKNOWN = 0,
  ARRIVING_AT_RESTAURANT = 1,
  AT_RESTAURANT = 2,
  ON_ITS_WAY = 3,
  DELIVERED = 4,
}
